import React, { useState } from "react";
import { Button, Card, Col, Flex, Row, Form, Typography, Divider, Tooltip, Space, Drawer } from 'antd'
import { ActionButton, MyInput, MySelect } from '../../../components'
import { skills } from '../../../shared'
import { getQuoteData } from "../../../data";
import { AddAppointmentModal } from "./AddappointmentModal";

const { Text, Title } = Typography
const GetProDrawers = ({visible,onClose}) =>{
    
    const [showappointment, setShowAppointment] = useState(false)
    const [appointmodal, setAppointModal] = useState(false)
    const [form] = Form.useForm();

    return (
        <>
        <Drawer
            title={"Get a Pro"}
            onClose={onClose}
            className="drawer"
            open={visible}
            width={800}
            footer={
                <Flex justify="end" gap={10}>
                    <Button onClick={onClose} className="btn-cancel">
                        Cancel
                    </Button>
                    <Button
                        className="btn"
                        type="primary"
                        htmlType="submit"
                    >
                        Save
                    </Button>
                </Flex>
            }
        >
            <Title level={4} className="text-brand">Pro Details</Title>
            <Form
                form={form}
                layout='vertical'
                requiredMark={false}
                className='mt-3'
            >
                <Row gutter={[16, 16]}>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                        <MySelect
                            label='Choose Service'
                            name='service'
                            required
                            message='Please enter work'
                            options={skills}
                            showSearch
                        />
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                        <MySelect
                            label='Date of project'
                            name='datepro'
                            required
                            message='Please enter date of project'
                            options={[
                                {
                                    id: 1,
                                    name: 'Urgent'
                                },
                                {
                                    id: 2,
                                    name: 'Flexible'
                                }
                            ]}
                        />
                    </Col>
                    <Col span={24}>
                        <MyInput
                            textArea
                            label='Project description'
                            name='projectdesc'
                            required
                            message='Please enter project description'
                            placeholder='write description...'
                        />
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                        <MyInput
                            label='Budget (min)'
                            name='budmin'
                            required
                            message='Please enter budget (min)'
                            placeholder=''
                        />
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                        <MyInput
                            label='Budget (max)'
                            name='budmax'
                            required
                            message='Please enter budget (max)'
                            placeholder=''
                        />
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Button className="btn mt-2"
                            onClick={() => {
                                setShowAppointment(true)
                            }}
                        >
                            Choose a Service
                        </Button>
                    </Col>
                    {
                        showappointment &&
                        getQuoteData?.map((professional, index) =>
                            <Col span={12} key={index}>
                                <Card className="border-brand">
                                    <Flex vertical gap={3} className="mb-2">
                                        <Flex justify="space-between" align="center">
                                            <Title level={5} className="m-0">
                                                {professional?.title}
                                            </Title>
                                            <ActionButton
                                                title='Add Appointment'
                                                className="border0 brown-bg text-white"
                                                icon={<img src="/assets/icons/appoint.png"  width={30}/>}
                                                onClick={() => setAppointModal(true)}
                                            />
                                        </Flex>
                                        <Text type="secondary" strong className="fs-14">
                                            {
                                                professional?.subtitle
                                            }
                                        </Text>
                                    </Flex>
                                    <Divider className="my-2" />
                                    <Row gutter={[16, 12]}>
                                        {professional?.details?.map((prodetail, i) => (
                                            <Col span={12} key={i}>
                                                <Flex align="center" gap={5}>
                                                    <div className="fs-16">
                                                        {prodetail?.icon}
                                                    </div>
                                                    <Text className="fs-14">
                                                        {prodetail?.title}
                                                    </Text>
                                                </Flex>
                                            </Col>
                                        ))}
                                    </Row>
                                </Card>

                            </Col>
                        )
                    }
                </Row>
            </Form>
        </Drawer>
        
        </>
    );
};

export { GetProDrawers };
